import React, { useState } from 'react';

const ComprehensiveMathTable = () => {
  const [startNumber, setStartNumber] = useState(1);
  const [endNumber, setEndNumber] = useState(10);
  const [mathTable, setMathTable] = useState([]);

  const generateTable = () => {
    if (startNumber < 1 || endNumber > 99 || startNumber > endNumber) {
      alert("Please enter a valid range (1 to 99) and ensure start is less than or equal to end.");
      return;
    }

    const table = [];
    for (let x = startNumber; x <= endNumber; x++) {
      table.push({
        x,
        square: x ** 2,
        cubeTimes10DivX: (x ** 3 * 10) / x,
        squareRoot: Math.sqrt(x).toFixed(4),
        reciprocalSquareRoot: (1 / Math.sqrt(x)).toFixed(4),
        cubeRoot: Math.cbrt(x).toFixed(4),
        cubeRoot10X: Math.cbrt(10 * x).toFixed(4),
        cubeRoot100X: Math.cbrt(100 * x).toFixed(4),
      });
    }
    setMathTable(table);
  };

  return (
    <div>
      <h2>Comprehensive Math Table Generator</h2>
      <label htmlFor="startNumber">Start Number (1-99): </label>
      <input
        type="number"
        id="startNumber"
        min="1"
        max="99"
        value={startNumber}
        onChange={(e) => setStartNumber(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="endNumber">End Number (1-99): </label>
      <input
        type="number"
        id="endNumber"
        min="1"
        max="99"
        value={endNumber}
        onChange={(e) => setEndNumber(parseInt(e.target.value))}
      />
      <br />
      <button onClick={generateTable}>Generate Table</button>

      {mathTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>x</th>
              <th>x²</th>
              <th>x³ × 10 / x</th>
              <th>√x</th>
              <th>1 / √x</th>
              <th>³√x</th>
              <th>³√(10x)</th>
              <th>³√(100x)</th>
            </tr>
          </thead>
          <tbody>
            {mathTable.map((row, index) => (
              <tr key={index}>
                <td>{row.x}</td>
                <td>{row.square}</td>
                <td>{row.cubeTimes10DivX}</td>
                <td>{row.squareRoot}</td>
                <td>{row.reciprocalSquareRoot}</td>
                <td>{row.cubeRoot}</td>
                <td>{row.cubeRoot10X}</td>
                <td>{row.cubeRoot100X}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ComprehensiveMathTable;
